/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import isString from"./isString";const decodeHTML=function(e){isString(e)||(e=`${e}`);let r="";return 0===e.length?"":(r=e.replace(/&amp;/g,"&"),r=r.replace(/&lt;/g,"<"),r=r.replace(/&gt;/g,">"),r=r.replace(/&nbsp;/g," "),r=r.replace(/'/g,"'"),r=r.replace(/&quot;/g,'"'),r=r.replace(/<br>/g,"\n"),r)};export default decodeHTML;